/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Mod6_TitleInputs */

const es_landing_mod6_title = /** @type {(inputs: Landing_Mod6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu barco comercial, mejor gestionado`)
};

const gl_landing_mod6_title = /** @type {(inputs: Landing_Mod6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu barco comercial, mellor xestionado`)
};

const en_landing_mod6_title = /** @type {(inputs: Landing_Mod6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your commercial boat, better managed`)
};

/**
* | output |
* | --- |
* | "Your commercial boat, better managed" |
*
* @param {Landing_Mod6_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_mod6_title = /** @type {((inputs?: Landing_Mod6_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Mod6_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_mod6_title(inputs)
	if (locale === "en") return en_landing_mod6_title(inputs)
	return es_landing_mod6_title(inputs)
});